// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"a0e07a9a","325":"ec034bca","413":"8720e94a","453":"9bf8e40c","511":"b7bdd0a2","594":"ae0b9227","607":"f3d6dbc2","780":"6469d9b8","815":"59de56b1","936":"c47e7803"}[chunkId] + ".chunk.js";
};